import React from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import { ManageContractsApp } from '../contractManagementContext';
import { ManageContractsCheckbox } from '../ManageContractsRadioCheckbox';

import Button from '../../../Common/Button';

// Types.
import { OmaLummeAddOnTemplate } from '../../../../types/contract';
// Utils.
import { checkHouseType } from '../../../../utils/contractManagement';

type ExtraServiceProps = {
  index: number;
  extraServices: number[];
  template: OmaLummeAddOnTemplate;
};

const ExtraService: React.FunctionComponent<ExtraServiceProps> = (props: ExtraServiceProps) => {
  const { t } = useTranslation();
  const { index, extraServices, template } = props;
  const [serviceOpen, setServiceOpen] = React.useState<boolean>(false);

  const dispatch = ManageContractsApp.useDispatch();

  const tariff = template.tariffs[0];
  const tariffElement = tariff.tariffElements[0];
  const salesText = template.salesTexts.find((text) => text.id === 2)?.salesText;

  return (
    <div className="extraService">
      <ManageContractsCheckbox
        radioID={`extraServices-${index}`}
        radioName={`extraServices-${index}`}
        onChangeFunc={(): void => {
          let extras = [...extraServices];

          if (!extras.includes(template.addonProductTemplateNo)) {
            extras.push(template.addonProductTemplateNo);
          } else {
            extras = extras.filter((e) => e !== template.addonProductTemplateNo);
          }

          dispatch(['changeServices', extras]);
        }}
        checkedComparison={extraServices?.includes(template.addonProductTemplateNo)}
        label={`${tariff.externalName} <span>${tariffElement.priceInclVat.toFixed(2).replace('.', ',')} ${
          tariffElement.unitPrice === 'EUR/kk' ? t('manageContracts:manageContracts.TableBaseUnit') : tariffElement.unitPrice
        }</span>`}
        extraHtml={
          salesText && serviceOpen ? (
            <div>
              {parse(salesText)}
              <Button type="button" className="buttonWhiteSmall" onClick={() => setServiceOpen(false)}>
                {t('common:general.readLess')}
              </Button>
            </div>
          ) : salesText ? (
            <div>
              <Button type="button" className="buttonWhiteSmall" onClick={() => setServiceOpen(true)}>
                {t('common:general.readMore')}
              </Button>
            </div>
          ) : undefined
        }
      />
    </div>
  );
};

export const ExtraServices: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { houseType, addOnTemplates, extraServices } = ManageContractsApp.useState();

  return (
    <>
      {addOnTemplates.length === 0 && houseType && (
        <section className="manage-contracts-step extraServices">
          <p>{t(`manageContracts:manageContracts.NoExtraServicesAvailable`)}</p>
        </section>
      )}
      {addOnTemplates.length > 0 && houseType && (
        <section className="manage-contracts-step extraServices">
          <h3>{t('manageContracts:manageContracts.ExtraServicesTitle')}</h3>
          {/* extra services body text hidden until there's more than one extraservice available */}
          {/* <p>{t("manageContracts:manageContracts.ExtraServicesBody")}</p> */}

          <div className="form-items extraServices-selection">
            {addOnTemplates.map((template, i) => {
              const templateName = template.addonProductTemplateName.toLowerCase();

              if (
                template &&
                ((houseType && checkHouseType(houseType, templateName)) ||
                  (houseType === 'flat' && templateName.toLowerCase().includes('ilmastoteko')) ||
                  templateName.toLowerCase().includes('fossiilivapaa energia'))
              ) {
                const tariff = template.tariffs[0];

                return <ExtraService key={tariff.tariffNo} index={i} extraServices={extraServices} template={template} />;
              }
              return false;
            })}
          </div>
        </section>
      )}
    </>
  );
};

export default ExtraServices;
